import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ProjectsSchema from 'schemas/customFields.schema.json';
import { updateCustomField } from 'utils/CustomFieldUtils';
import { useFormContext } from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';
import { useAppContext } from 'hooks/useAppContext';
import CustomFieldGrid from './CustomFieldGrid';
import AuthCheck from 'components/Shared/AuthCheck';
import ODataUtil from 'utils/ODataUtil';

const CustomFields = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    defaultValues = ODataUtil.unCoupleExpandsFromDefaults(defaultValues);
    console.log(defaultValues)
    const formContext = useFormContext()
    const { selectedProject } = useAppContext();
    const [updateDate, setUpdateDate] = useState(new Date());

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ProjectsSchema)
    })

    const onSubmit = async (values) => {
        let result
        if (CRUDType === "UPDATE") {
            result = await updateCustomField(values, selectedProject)
            setUpdateDate(new Date())
            setTimeout(callback, 1000)
        }
        return result
    }
    return (
    <div style={{ padding: '15px' }}>
        <AuthCheck scope="CustomFields" action="create">
            {
                formContext.ready ?
                    withExtension(DynamicForm, { schema: ProjectsSchema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions }) :
                    <SkeletonForm />
            }
        </AuthCheck>
        <CustomFieldGrid key={updateDate} />
    </div>
    )
}

CustomFields.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

CustomFields.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}

export default CustomFields